<template>
  <div class="CorporationD">
    <PageContent>
      <StepsV2 type="s3" :step="1" />
      <PanelV2
        type="w6"
        title="Enter your business details"
        @nextClick="commitData"
      >
        <template v-slot:title-solt>
          <BdoProgress total="4" step="1" />
        </template>
        <template v-slot:content-solt>
          <AppForm
            ref="appForm"
            v-model="formData"
            />
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
  import AppForm from "../forms/NewMerchantCorpD.val";
  import API from "@/api";
  export default {
    name: 'CorporationD',
    pRouter: 'CorporationC',
    components: {
      AppForm,
    },
    data() {
      return {
        formData: '',
      }
    },
    methods: {
      commitData() {
        this.$refs.appForm.$refs.appForm.validate((valid) => {
          if (valid) {
            const data = this.formatCommitData({...this.formData})
            API.addBdoProcess({
              ...data
            }).then((res) => {
              if (res.success === true) {
                this.toNext();
              }
            });
          }
        });
      },
    }
  }
</script>


<style lang="scss" scoped>
.CorporationD {
  ::v-deep .content {
    margin-bottom: 138px;
  }
  .content > div {
    width: 100%;
  }
}
</style>
